import { Component, type ReactNode } from "react";
import { useI18n } from "../../i18n";

export function Status({ value }: { value: string }) {
  const { t, has } = useI18n();
  const key = `status.${value}`;
  return (
    <span className={`status status-${value.toLowerCase().replaceAll("_", "-")}`}>
      {has(key) ? t(key) : value}
    </span>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return <div className="empty-state">{children}</div>;
}

export function PageLoading() {
  const { t } = useI18n();
  return (
    <div className="loading-state" role="status">
      {t("common.working")}
    </div>
  );
}

class PageErrorBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

export function PageLoadBoundary({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  return (
    <PageErrorBoundary
      fallback={
        <div className="empty-state" role="alert">
          <p>{t("errors.fallback")}</p>
          <button type="button" onClick={() => window.location.reload()}>
            {t("common.refresh")}
          </button>
        </div>
      }
    >
      {children}
    </PageErrorBoundary>
  );
}
